/**
 * This code was generated by Builder.io.
 */
import React from "react";

const InfoCard = ({ imageSrc, title, description }) => (
  <div className="info-card">
    <img loading="lazy" src={imageSrc} className="card-image" alt="" />
    <div className="card-content">
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
    </div>
  </div>
);

export default InfoCard;
